import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoyaltyCardsService } from './services';
import { LoyaltyCardStateModule } from './+state/loyalty-cards.state.module';
import { LoyaltyCardsFacade } from './+state';

@NgModule({
  imports: [CommonModule, LoyaltyCardStateModule],
})
export class DomainLoyaltyCardsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainLoyaltyCardsModule,
      providers: [LoyaltyCardsService, LoyaltyCardsFacade],
    };
  }
}
